import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormValidationError } from '@shared/models/interfaces/form-validation-error.interface';
import { toNum } from '@shared/helpers/math.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { CHECK_THE_ENTERED_VALUE, REQUIRED_STATUS } from '@shared/constants/shared.constants';

/**
 * Sync validators on the control value: the store lags behind the form (debounced write + listener bursts),
 * a store-based async validator read a stale snapshot (false "required") and answered up to 250ms late.
 */
@Injectable({ providedIn: 'root' })
export class BaseSocialeFieldValidators {
    my_SociFisCoopData: ValidatorFn = (control) => this._my_SociDataHelper(control, 'my_SociFisCoopData');

    my_SociGiuCoopData: ValidatorFn = (control) => this._my_SociDataHelper(control, 'my_SociGiuCoopData');

    my_SociFisFinData: ValidatorFn = (control) => this._my_SociDataHelper(control, 'my_SociFisFinData');

    my_SociGiuFinData: ValidatorFn = (control) => this._my_SociDataHelper(control, 'my_SociGiuFinData');

    private _my_SociDataHelper(control: AbstractControl, fieldName: string): ValidationErrors | null {
        const my_SociData = toNum(control?.value);
        let error: FormValidationError = null;

        if (isNilOrEmpty(my_SociData)) {
            error = { status: REQUIRED_STATUS };
        } else if (my_SociData < 0) {
            error = { status: CHECK_THE_ENTERED_VALUE };
        }
        return error ? { [fieldName]: error } : null;
    }
}
